import moment from 'moment';
import { calculateTime, calculateHoursBetweenDates } from 'utils/dateAndTimeUtils';
import { format, parseISO } from 'date-fns';

export const getEventData = (event) => {
  switch (event.event_name) {
    case 'start_timer':
      return {
        boldText: `Timer started`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        timeSpent: event.from ? calculateTime(event.from) : ''
      };
    case 'add_timer':
      return {
        boldText: `Time entry added`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        startDateTime: event.from ?? '',
        endDateTime: event.to ?? '',
        event_id: event.id
      };
    case 'deleted_add_timer':
      return {
        boldText: `Time entry removed`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.description ? event.description : '',
        startDateTime: '',
        endDateTime: '',
        event_id: event.id
      };
    case 'deleted_stop_timer':
      return {
        boldText: `Time entry removed`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.description ? event.description : '',
        startDateTime: '',
        endDateTime: '',
        event_id: event.id
      };
    case 'stop_timer':
      let timeSpent = '';
      if (event?.to) {
        const { total } = calculateHoursBetweenDates({ startDate: event?.from, endDate: event?.to, withSeconds: true });
        timeSpent = total;
      } else {
        timeSpent = calculateTime(event?.from);
      }
      return {
        boldText: `Timer stopped`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        startDateTime: event.from ?? '',
        endDateTime: event.to ?? '',
        event_id: event.id,
        timeSpent: timeSpent ?? ''
      };
    case 'created':
      return {
        boldText: `Created on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'assigned':
      return {
        boldText: event.description ?? '',
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : ''
      };
    case 'unassigned':
      return {
        boldText: `Reopened on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'no_access':
      return {
        boldText: `Marked as No Access on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'assignment_revoked':
      return {
        boldText: `Assignment revoked on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'cancelled':
      return {
        boldText: `Cancelled on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'completed':
      return {
        boldText: `Completed on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'withdrawn':
      return {
        boldText: `Assignment rejected on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'callback':
      return {
        boldText: `Callback on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'reopen':
      return {
        boldText: `Reopened on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'rating':
      return {
        boldText: `Rated on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'create_part':
      return {
        boldText: `Part requested on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'update_part':
      return {
        boldText: `Part updated on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'part_ordered':
      return {
        boldText: `Part ordered on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'part_delivered':
      return {
        boldText: `Part delivered on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'tech_dispatched':
      return {
        boldText: `Tech dispatched on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description
      };
    case 'edited':
      return {
        boldText: `Edited on`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : '',
        attachments: event.attachments,
        description: event.description ?? ''
      };
    case 'resident_call':
      return {
        boldText: `Resident Call`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : ''
      };
    case 'unit_added':
      return {
        boldText: event.description ?? '',
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : ''
      };
    case 'scheduled_for':
      return {
        boldText: `Scheduled for ${format(parseISO(event.description), 'MM/dd/yy')} `,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        by: event.created_by ? `by ${event.created_by}` : ''
      };
    case 'post_error_cleared':
      return {
        boldText: `Post Error Cleared by ${event.created_by}`,
        timeStamp: moment.utc(event.datetime).local().format('MM/DD/YY hh:mm A'),
        description: event.description,
        expandable: true
      };
    default:
      return {
        boldText: 'Bold text',
        text: 'text'
      };
  }
};
